export const FIXED = {
  value: "FIXED",
  key: "clientClasses.form.fiscalSplit.types.fixed",
};
export const PERCENTAGE = {
  value: "PERCENTAGE",
  key: "clientClasses.form.fiscalSplit.types.percentage",
};

export default [FIXED, PERCENTAGE];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/enums/fiscalSplitTypes.js